import { Component, OnDestroy, OnInit } from "@angular/core";

import { RouterModule } from "@angular/router";
import { PrivacyPolicyComponent } from "../../common/privacy-policy/privacy-policy.component";
import { TermsComponent } from "../../common/terms/terms.component";

@Component({
  selector: "app-footer",
  templateUrl: "./app-footer.component.html",
  styleUrls: ["./app-footer.component.scss"],
  imports: [RouterModule, PrivacyPolicyComponent, TermsComponent],
})

export class AppFooterComponent implements OnInit, OnDestroy {
  
  constructor() {}

  ngOnInit(): void {
 
  }
  ngOnDestroy(): void {
    throw new Error("Method not implemented.");
  }
}